import React, {Component, ReactElement} from 'react'

import NatCondominiumRepo from './repository/NatCondominiumRepo'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetCondominiumList'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import {SortOrder} from '../../../components/shared/SortOrder'
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortDirection} from '@mui/material/TableCell'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import {
    BILLING_DEADLINE,
    CONFIRMATION_STATUS,
    DETAIL_SEARCH_CONDITION,
    TARGET_YEAR_MONTH,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCellForColgroup,
    ConditionTableBody,
    ConditionTableFixed,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import styled from 'styled-components'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {addEmptyData} from '../../../componentHelper/selectHelper'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material'
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_SEARCH_CONDITION: string = 'adminCondominiumListPageSearchCondition'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'

interface Props {
    CondominiumRepo: NatCondominiumRepo
    CondominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    condominiums: CondominiumInfo[]
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    searchResult: SearchResult
    loginUserCondominiumGroupId: number | null
    isLoadCompleted: boolean
    currentDate: Date
}

interface LastSearchCondition {
    condominiumCd?: string
    condominiumName?: string
    condominiumGroupId?: number
    detailSearchCondition?: string
    billingStatus?: BillingStatus
    pageNum?: number
}

class NatAdminCondominiumListPage extends Component<Props & AdminPagePropsSet, States> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        // 前回検索条件からデフォルト値を生成
        const lastSearchCondition = this.getLastSearchCondition()
        const defaultSearchCondition =
            this.initDefaultSearchCondition(lastSearchCondition, loginUserCondominiumGroupId)
        const defaultSearchConditionPage = this.initDefaultSearchConditionPage(lastSearchCondition)

        this.state = {

            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            condominiums: [],
            searchCondition: defaultSearchCondition,
            searchConditionPageInfo: defaultSearchConditionPage,
            searchConditionSortInfo: [
                new SortOrder('updateDatetime', 'desc'),
                new SortOrder('condominiumCd', 'desc'),
            ],
            searchResult: {
                ['total']: 0,
                ['totalPage']: 0,
                ['start']: 0,
                ['end']: 0,
            },
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            isLoadCompleted: false,
            currentDate: new Date(0, 0),

        }
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleSortCondominiums = this.handleSortCondominiums.bind(this)
        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeDetailSearchCondition = this.onChangeDetailSearchCondition.bind(this)
        this.onChangeBillingDeadLine = this.onChangeBillingDeadLine.bind(this)
        this.onChangeConfirmStatus = this.onChangeConfirmStatus.bind(this)
        this.onChangeTargetYearMonth = this.onChangeTargetYearMonth.bind(this)
        this.onChangeElectedTargetYearMonth = this.onChangeElectedTargetYearMonth.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.registerCondominium = this.registerCondominium.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                this.props.CondominiumGroupRepo.getCondominiumGroup.bind(this.props.CondominiumGroupRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (condominiumGroupResponse) {
                this.setState({
                    condominiumGroup: condominiumGroupResponse,
                })
                // 前回検索条件が設定されていない場合、ログインユーザの所属する物件グループを設定する
                const condition: SearchCondition = this.state.searchCondition

                // 物件検索結果取得
                await this.searchCondominiums(
                    condition,
                    this.state.searchConditionPageInfo,
                    this.state.searchConditionSortInfo,
                )
            }
            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                // 出力条件「利用年月」にて使用するstateを設定
                const currentDate = new Date(currentDateTime.details.currentDateTime)
                this.setState({
                    currentDate: currentDate,
                })
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    saveLastSearchCondition(): void {
        const lastSearchCondition: LastSearchCondition = {
            condominiumCd: this.state.searchCondition.condominiumCd || undefined,
            condominiumName: this.state.searchCondition.condominiumName || undefined,
            condominiumGroupId: this.state.searchCondition.condominiumGroupId || undefined,
            detailSearchCondition: this.state.searchCondition.detailSearchCondition || undefined,
            billingStatus: this.state.searchCondition.billingStatus || undefined,
            pageNum: this.state.searchConditionPageInfo.pageNum,
        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))
    }

    getLastSearchCondition(): LastSearchCondition {
        let lastSearchCondition: LastSearchCondition = {}
        const sessionStorageSearchCondition: string | null =
            SessionStorageHelper.getStringItemOrNull(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        }
        return lastSearchCondition
    }

    initDefaultSearchCondition(
        latest: LastSearchCondition,
        loginUserCondominiumGroupId: Nullable<number>,
    ): SearchCondition {

        let result: SearchCondition = {
            condominiumCd: null,
            condominiumName: null,
            condominiumGroupId: loginUserCondominiumGroupId,
            prefectureCd: '',
            address2: '',
            detailSearchCondition: DETAIL_SEARCH_CONDITION.NO_CONDITION.value,
            billingStatus: {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            },
            unreleaseCondominiumExclusionFlg: null,
        }
        if (Object.keys(latest).length) {
            let billingStatus
            if (latest.billingStatus) {
                billingStatus = {
                    billingDeadline: latest.billingStatus.billingDeadline || null,
                    confirmStatus: latest.billingStatus.confirmStatus || null,
                    targetYearMonth: latest.billingStatus.targetYearMonth || null,
                    electedTargetYearMonth: latest.billingStatus.electedTargetYearMonth || null,
                }
            } else {
                billingStatus = {
                    billingDeadline: null,
                    confirmStatus: null,
                    targetYearMonth: null,
                    electedTargetYearMonth: null,
                }
            }

            result = {
                condominiumCd: latest.condominiumCd || result.condominiumCd,
                condominiumName: latest.condominiumName || result.condominiumName,
                condominiumGroupId: latest.condominiumGroupId || result.condominiumGroupId,
                prefectureCd: '',
                address2: '',
                detailSearchCondition: latest.detailSearchCondition || result.detailSearchCondition,
                billingStatus: {
                    billingDeadline: billingStatus.billingDeadline || result.billingStatus.billingDeadline,
                    confirmStatus: billingStatus.confirmStatus || result.billingStatus.confirmStatus,
                    targetYearMonth: billingStatus.targetYearMonth || result.billingStatus.targetYearMonth,
                    electedTargetYearMonth: billingStatus.electedTargetYearMonth
                        || result.billingStatus.electedTargetYearMonth,
                },
                unreleaseCondominiumExclusionFlg: result.unreleaseCondominiumExclusionFlg,
            }
        }
        return result
    }

    initDefaultSearchConditionPage(latest: LastSearchCondition): SearchConditionPageInfo {

        return {
            pageNum: latest.pageNum ? latest.pageNum : COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    // 登録ボタン押下
    async registerCondominium(): Promise<void> {
        this.props.navigate(
            '/admin/condominiumRegister',
        )
    }

    // 物件検索
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const requestSearchCondition = this.createRequestSearchCondition(searchCondition)
            const searchParams: string[] = []
            if (searchConditionSortInfo) {

                searchConditionSortInfo.forEach((sortInfo, index) => {
                    const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                    searchParams.push(value)
                })

                // ソートのサブキーを追加
                const sortOrder: SortOrder | undefined =
                    searchConditionSortInfo.find(order => order.sortKey === 'condominiumCd')

                if (sortOrder === undefined) {
                    const subSortKey: string = `condominiumCd:asc`
                    searchParams.push(subSortKey)
                }

            } else {
                // ソートのサブキーを追加
                const subSortKey: string = `condominiumCd:asc`
                searchParams.push(subSortKey)
            }

            // 物件一覧取得
            const getCondominiumResponse: Nullable<NatGetCondominiumList> =
                await this.props.asyncCallFunction(
                    this.props.CondominiumRepo.getCondominiumList.bind(
                        this.props.CondominiumRepo,
                        {...requestSearchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getCondominiumResponse) {
                if (getCondominiumResponse.details) {
                    this.setState({
                        condominiums: getCondominiumResponse.details.condominiumInfo,
                        searchResult: getCondominiumResponse.details.searchResult,
                    })
                }

            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    createRequestSearchCondition(searchCondition: SearchCondition): SearchCondition {
        // searchConditionをディープコピーして、検索用パラメータを作成
        const requestSearchCondition = {
            ...searchCondition,
            billingStatus: {
                ...searchCondition.billingStatus,
            },
        }
        // 対象年月が指定月かつ指定対象年月がデフォルト値の場合に設定するダミー値
        const dummyYearMonth = '999912'

        if (searchCondition.billingStatus.billingDeadline === 'none') {
            requestSearchCondition.billingStatus.billingDeadline = null
        }
        if (searchCondition.billingStatus.targetYearMonth === '0') {
            const targetYear = this.state.currentDate.getFullYear()
            const targetMonth = this.state.currentDate.getMonth() + 1
            requestSearchCondition.billingStatus.electedTargetYearMonth = `${String(targetYear)}${('00' + targetMonth).slice(-2)}`
        } else if (searchCondition.billingStatus.electedTargetYearMonth === 'none') {
            requestSearchCondition.billingStatus.electedTargetYearMonth = dummyYearMonth
        }
        return requestSearchCondition
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.condominiums.length === 0) {
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.searchResult.total,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.searchCondominiums(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo)

        // 検索条件を保持
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
        this.saveLastSearchCondition()
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.searchCondominiums(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
        this.saveLastSearchCondition()
    }

    async handleSortCondominiums(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.searchCondominiums(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    renderCondominiumTable(condominiums: CondominiumInfo[]): Nullable<ReactElement> {
        if (condominiums.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {
                id: 'condominiumCd',
                label: '物件コード',
                sortable: true,
                direction: this.getSortDirection('condominiumCd'),
            },
            {id: 'condominiumName', label: '物件名'},
            {id: 'condominiumGroupName', label: '物件グループ'},
            {
                id: 'updateDatetime',
                label: '更新日時',
                sortable: true,
                direction: this.getSortDirection('updateDatetime'),
            },
            {id: 'status', label: '非公開'},
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortCondominiums}
                />
                <SortablePaginationTableBody>
                    {this.state.condominiums.map(
                        condominium => this.renderCondominiumRecord(condominium),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    setReleaseText(releaseFlg: string): string {
        const validOrNotCheck = VALID_OR_NOT_CHECK.codeToEnumConstants(releaseFlg)
        if (validOrNotCheck) {
            return validOrNotCheck.label
        } else {
            return ''
        }
    }

    renderCondominiumRecord(condominium: CondominiumInfo): ReactElement {
        const condominiumUrl: string = `/admin/condominium/${condominium.condominiumCd}`
        return (
            <TableRow key={condominium.condominiumCd}>
                <TableCell align={'left'}><Link href={condominiumUrl}
                                                underline="hover">{condominium.condominiumCd}</Link></TableCell>
                <TableCellWordBreakAll align={'left'}>{condominium.condominiumName}</TableCellWordBreakAll>
                <TableCell align={'left'}>{condominium.condominiumGroupName}</TableCell>
                <TableCell align={'center'}>{formatDateTimeForUpdateDate(condominium.updateDatetime)}</TableCell>
                <TableCell align={'center'}>{this.setReleaseText(condominium.releaseFlg)}</TableCell>
            </TableRow>
        )
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    // 請求締め日
    getBillingDeadLineRadioGroupData(): PPRadioItemProp[] {
        const billingDeadLineRadioGroupData: PPRadioItemProp[] = []
        BILLING_DEADLINE.values().map((billingDeadLine) => (
            billingDeadLineRadioGroupData.push(
                {
                    label: billingDeadLine.label,
                    value: billingDeadLine.value,
                    radioProps: {
                        checked: billingDeadLine.value === this.state.searchCondition.billingStatus.billingDeadline,
                        onChange: this.onChangeBillingDeadLine,
                    },
                },
            )
        ))
        return [{
            label: 'すべて',
            value: 'none',
            radioProps: {
                checked: this.state.searchCondition.billingStatus.billingDeadline === 'none',
                onChange: this.onChangeBillingDeadLine,
            },
        }, ...billingDeadLineRadioGroupData]
    }

    // 確認ステータス
    getConfirmStatusRadioGroupData(): PPRadioItemProp[] {
        const confirmStatusRadioGroupData: PPRadioItemProp[] = []
        CONFIRMATION_STATUS.values().map((confirmStatus) => (
            confirmStatusRadioGroupData.push(
                {
                    label: confirmStatus.label,
                    value: confirmStatus.value,
                    radioProps: {
                        checked: confirmStatus.value === this.state.searchCondition.billingStatus.confirmStatus,
                        onChange: this.onChangeConfirmStatus,
                    },
                },
            )
        ))
        return confirmStatusRadioGroupData
    }

    // 対象年月
    getTargetYearMonthRadioGroupData(): PPRadioItemProp[] {
        const targetYearMonthRadioGroupData: PPRadioItemProp[] = []
        TARGET_YEAR_MONTH.values().map((targetYearMonth) => (
            targetYearMonthRadioGroupData.push(
                {
                    label: targetYearMonth.label,
                    value: targetYearMonth.value,
                    radioProps: {
                        checked: targetYearMonth.value === this.state.searchCondition.billingStatus.targetYearMonth,
                        onChange: this.onChangeTargetYearMonth,
                    },
                },
            )
        ))
        return targetYearMonthRadioGroupData
    }

    // 指定対象年月
    getElectedTargetYearMonth(): OptionProps[] {
        const yearMonths: OptionProps[] = []
        let targetYear = this.state.currentDate.getFullYear()
        let targetMonth = this.state.currentDate.getMonth() + 1
        for (let i = 0; i < 11; i++) {
            if (targetMonth === 1) {
                targetMonth = 12
                targetYear = targetYear - 1
            } else {
                targetMonth = targetMonth - 1
            }
            const targetYearMonthLabel = `${String(targetYear)}年${('00' + targetMonth).slice(-2)}月`
            const targetYearMonthValue = `${String(targetYear)}${('00' + targetMonth).slice(-2)}`
            yearMonths.push({
                label: String(targetYearMonthLabel),
                value: String(targetYearMonthValue),
            })
        }
        return yearMonths
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.searchCondominiums(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.condominiumCd = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.condominiumName = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeCondominiumGroupId(condomoniumGroupId: number): void {
        const seachConditions = this.state.searchCondition
        seachConditions.condominiumGroupId = condomoniumGroupId
        this.setState({searchCondition: seachConditions})
    }

    onChangeDetailSearchCondition(event: SelectChangeEvent<unknown>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.detailSearchCondition = event.target.value as string
        if (event.target.value as string === DETAIL_SEARCH_CONDITION.BILLING_STATUS.value) {
            this.setState({
                searchCondition: {
                    ...searchCondition,
                    billingStatus: {
                        billingDeadline: 'none',
                        confirmStatus: CONFIRMATION_STATUS.UNCONFIRMED.value,
                        targetYearMonth: TARGET_YEAR_MONTH.THIS_YEAR_MONTH.value,
                        electedTargetYearMonth: 'none',
                    },
                },
            })
        } else if (event.target.value as string === DETAIL_SEARCH_CONDITION.NO_CONDITION.value) {
            this.setState({
                searchCondition: {
                    ...searchCondition,
                    billingStatus: {
                        billingDeadline: null,
                        confirmStatus: null,
                        targetYearMonth: null,
                        electedTargetYearMonth: null,
                    },
                },
            })
        }
    }

    onChangeBillingDeadLine(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.billingStatus.billingDeadline = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeConfirmStatus(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.billingStatus.confirmStatus = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeTargetYearMonth(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.billingStatus.targetYearMonth = event.target.value
        if (event.target.value === TARGET_YEAR_MONTH.THIS_YEAR_MONTH.value) {
            searchCondition.billingStatus.electedTargetYearMonth = 'none'
            this.setState({searchCondition: searchCondition})
        } else {
            this.setState({searchCondition: searchCondition})
        }
    }

    onChangeElectedTargetYearMonth(event: SelectChangeEvent<unknown>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.billingStatus.electedTargetYearMonth = event.target.value as string
        this.setState({searchCondition: searchCondition})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                > <ConditionTableFixed>
                    <colgroup>
                        <col width={'20%'}/>
                        <col width={'15%'}/>
                        <col width={'25%'}/>
                        <col width={'15%'}/>
                        <col width={'25%'}/>
                    </colgroup>
                    <ConditionTableBody>
                        <ConditionTableRow>
                            <ConditionCategoryCell rowSpan={2}>物件情報</ConditionCategoryCell>
                            <ConditionInputCellForColgroup>物件コード</ConditionInputCellForColgroup>
                            <ConditionInputCellForColgroup>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 6,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumCd}
                                    defaultValue={this.state.searchCondition.condominiumCd}
                                    autoFocus
                                />
                            </ConditionInputCellForColgroup>
                            <ConditionInputCellForColgroup>物件名</ConditionInputCellForColgroup>
                            <ConditionInputCellForColgroup>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumName}
                                    defaultValue={this.state.searchCondition.condominiumName}
                                />
                            </ConditionInputCellForColgroup>
                        </ConditionTableRow>
                        <ConditionTableRow>

                            <ConditionColumNameCell>物件グループを選択</ConditionColumNameCell>
                            <ConditionInputCellForColgroup colSpan={2}>
                                {
                                    this.state.condominiumGroup &&
                                    this.state.condominiumGroup.details &&
                                    <>
                                        <NatCondominiumGroupSelectComponent
                                            condominiumGroup={this.state.condominiumGroup.details}
                                            onChangeSelectedCondominiumGroupId=
                                                {this.onChangeCondominiumGroupId}
                                            defaultValue={(Number(this.state.searchCondition.condominiumGroupId)) ?
                                                Number(this.state.searchCondition.condominiumGroupId) : null}
                                            requiredFlag={true}
                                            eventKeys={['condominiumGroupId']}
                                            eventEmitter={this.props.eventEmitter}
                                        >
                                        </NatCondominiumGroupSelectComponent>
                                    </>
                                }
                            </ConditionInputCellForColgroup>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionCategoryCell rowSpan={4}>詳細検索</ConditionCategoryCell>
                            <ConditionInputCellForColgroup colSpan={3}>
                                <PPSelect
                                    data={DETAIL_SEARCH_CONDITION.values()}
                                    onChange={this.onChangeDetailSearchCondition}
                                    eventKeys={['detailSearchCondition']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.searchCondition.detailSearchCondition}
                                />
                            </ConditionInputCellForColgroup>
                            {(this.state.searchCondition.detailSearchCondition
                                === DETAIL_SEARCH_CONDITION.NO_CONDITION.value) ?
                                <>
                                    <ConditionButtonCell>
                                        <AdminDefaultMediumButton
                                            onClick={this.onClickSearchButton.bind(this)}>
                                            物件を検索する
                                        </AdminDefaultMediumButton>
                                    </ConditionButtonCell>
                                </> : null
                            }
                        </ConditionTableRow>
                        {(this.state.searchCondition.detailSearchCondition
                            === DETAIL_SEARCH_CONDITION.BILLING_STATUS.value) ?
                            <>
                                <ConditionTableRow>
                                    <ConditionInputCellForColgroup>請求締め日</ConditionInputCellForColgroup>
                                    <ConditionInputCellForColgroup>
                                        <PPRadioGroup
                                            name={'billingDeadLine'}
                                            row
                                            data={this.getBillingDeadLineRadioGroupData()}
                                            eventKeys={['billingDeadLine']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </ConditionInputCellForColgroup>
                                </ConditionTableRow>
                                <ConditionTableRow>
                                    <ConditionInputCellForColgroup>確認ステータス</ConditionInputCellForColgroup>
                                    <ConditionInputCellForColgroup>
                                        <PPRadioGroup
                                            name={'confirmStatus'}
                                            row
                                            data={this.getConfirmStatusRadioGroupData()}
                                            eventKeys={['confirmStatus']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </ConditionInputCellForColgroup>
                                </ConditionTableRow>
                                <ConditionTableRow>
                                    <ConditionInputCellForColgroup>対象年月</ConditionInputCellForColgroup>
                                    <ConditionInputCellForColgroup colSpan={2}>
                                        <LeftRowFlexContainer>
                                            <PPRadioGroup
                                                name={'targetYearMonth'}
                                                row
                                                data={this.getTargetYearMonthRadioGroupData()}
                                                eventKeys={['targetYearMonth']}
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                            <PPSelect
                                                disabled={this.state.searchCondition.billingStatus.targetYearMonth
                                                    === TARGET_YEAR_MONTH.THIS_YEAR_MONTH.value}
                                                data={addEmptyData(this.getElectedTargetYearMonth(), '対象年月を指定してください')}
                                                onChange={this.onChangeElectedTargetYearMonth}
                                                eventKeys={['electedTargetYearMonth']}
                                                eventEmitter={this.props.eventEmitter}
                                                value={this.state.searchCondition.billingStatus.electedTargetYearMonth}
                                            />
                                        </LeftRowFlexContainer>
                                    </ConditionInputCellForColgroup>
                                    <ConditionButtonCell>
                                        <AdminDefaultMediumButton
                                            onClick={this.onClickSearchButton.bind(this)}>
                                            物件を検索する
                                        </AdminDefaultMediumButton>
                                    </ConditionButtonCell>
                                </ConditionTableRow>
                            </> : null
                        }
                    </ConditionTableBody>
                </ConditionTableFixed>
                </ListSearchFormArea>
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CONDOMINIUM}>
                        <AdminDefaultMediumButton onClick={this.registerCondominium}>
                            新規
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </SearchPageActionArea>
                <PageMainArea>
                    {this.renderCondominiumTable(this.state.condominiums)}
                </PageMainArea>
            </>
        )
    }

}

export default createAdminPage(NatAdminCondominiumListPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    width: 40%;
    word-break: break-all;
  }
`
